import React from 'react';
import cn from 'classnames';
import styles from './Button.scss';

const Button = ({ className, children, ...rest }) => (
  <button type="button" className={cn(styles.Button, className)} {...rest}>{children}</button>
  );

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/Button/Button.js